exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".home[data-v-5d254dcb]{padding:50px}.display-message[data-v-5d254dcb],.home[data-v-5d254dcb]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.display-message[data-v-5d254dcb]{-ms-flex-direction:column;flex-direction:column;width:700px;height:500px;background:#fff;border-radius:20px}.display-message img[data-v-5d254dcb]{height:100px;margin-bottom:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d254dcb","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PageNotFound.vue
// module id = 845
// module chunks = 0